import { SimpleForm, TextInput, Create, SelectInput } from 'react-admin';

export const FeedCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <SelectInput
        source="type"
        label="Тип материала"
        choices={[
          { id: 'headings', name: 'Рубрика' },
          { id: 'course', name: 'Курс' },
          { id: 'challenge', name: 'Челлендж' },
          { id: 'mashtab', name: 'Масштаб' },
        ]}
      />
      <TextInput source="name" fullWidth label="Название" required />
      <TextInput source="description" fullWidth label="Описание" required />
      <TextInput source="url" fullWidth label="Ссылка" required />
      <TextInput source="img_url" fullWidth label="Пре изображение" required />
      <TextInput
        source="header_url"
        fullWidth
        label="Ссылка на шапку"
        required
      />
      <TextInput
        source="header_mobile_url"
        fullWidth
        label="Ссылка на мобильную шапку"
        required
      />
      <TextInput
        label="CSS настройка"
        variant="outlined"
        multiline
        minRows={4}
        maxRows={6}
        source="header_css"
        fullWidth
      />
      <TextInput source="header_icon_url" fullWidth label="Иконка" required />
    </SimpleForm>
  </Create>
);
